import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';
import {
  AppBar,
  UserMenu,
  useLocale,
  useSetLocale,
  useTranslate,
} from 'react-admin';
import Language from '@material-ui/icons/Language';
import {
  Title,
  CardImage,
  Spacer,
  MenuStyledItem,
  ListStyledItemIcon,
} from './CustomAppBar.styles';
import Constants from '../../utils/constants';

const SwitcherLang = forwardRef((props, ref) => {
  const locale = useLocale();
  const translate = useTranslate();
  const setLocale = useSetLocale();
  return (
    <MenuStyledItem
      ref={ref}
      onClick={() => {
        setLocale(locale === Constants.EN ? Constants.ES : Constants.EN);
        props.onClick();
      }}
    >
      <ListStyledItemIcon>
        <Language />
      </ListStyledItemIcon>
      {translate('custom.userMenu.changeLang')}
    </MenuStyledItem>
  );
});

SwitcherLang.displayName = 'SwitcherLang';

const CustomUserMenu = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <UserMenu {...props}>
    <SwitcherLang />
  </UserMenu>
);

const CustomAppBar = memo((props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <AppBar {...props} userMenu={<CustomUserMenu />}>
    <Title color="inherit" id="react-admin-title" variant="h6" />
    <CardImage image="/titleLogo.png" />
    <Spacer />
  </AppBar>
));

CustomAppBar.displayName = 'CustomAppBar';

SwitcherLang.propTypes = {
  onClick: PropTypes.func,
};

SwitcherLang.defaultProps = {
  onClick: () => {},
};

export default CustomAppBar;
